import { apiClient, shopMobilePath } from './client';

export type StaffRole = 'owner' | 'frontdesk' | 'technician' | 'finance';

export interface StaffMember {
  userId: string;
  role: StaffRole;
  displayName: string | null;
  phone: string;
  createdAt: string;
  bound: boolean;
}

export interface StaffListResult {
  items: StaffMember[];
  total: number;
}

export function getStaff() {
  return apiClient.get<StaffListResult>(shopMobilePath('/staff'));
}

export function addStaff(input: { phone: string; role: StaffRole; displayName?: string }) {
  return apiClient.post<{ userId: string; membershipId: string; role: StaffRole }>(
    shopMobilePath('/staff'),
    input,
  );
}

export function removeStaff(userId: string) {
  return apiClient.delete(shopMobilePath(`/staff/${userId}`));
}

export function updateStaffRole(userId: string, role: StaffRole) {
  return apiClient.patch(shopMobilePath(`/staff/${userId}`), { role });
}
